import type { PageSegmentLoadMetric } from '@atlassian/browser-metrics/page-segment-load';
import type { PageLoadMetric } from '@atlassian/browser-metrics/page-load-metric';

import {
	createPageLoadMetric,
	createPageSegmentLoadMetric,
	getWaterfallTimings,
} from '@confluence/browser-metrics/entry-points/metricConfigs.ts';
import {
	CONFLUENCE_HOME_LOAD_KEY,
	HOME_OVERVIEW_RECENT_SEGMENT_KEY,
	HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY,
	HOME_OVERVIEW_SPACES_SECTION_SEGMENT_KEY,
} from '@confluence/browser-metrics/entry-points/metric-keys.ts';
import { HOME_OVERVIEW_FEED_PAGE_SEGMENT } from '@confluence/feed/entry-points/perf.config.ts';

export const HOME_OVERVIEW_RECENT_PAGE_SEGMENT: PageSegmentLoadMetric = createPageSegmentLoadMetric(
	{
		key: HOME_OVERVIEW_RECENT_SEGMENT_KEY,
		// Set FMP = FCP if SSR (normally FMP = TTI)
		ssr: window.__SSR_RENDERED__ ? { doneAsFmp: true } : undefined,
	},
);

export const HOME_OVERVIEW_SPACES_SECTION_SEGMENT: PageSegmentLoadMetric =
	createPageSegmentLoadMetric({
		key: HOME_OVERVIEW_SPACES_SECTION_SEGMENT_KEY,
		// Set FMP = FCP if SSR (normally FMP = TTI)
		ssr: window.__SSR_RENDERED__ ? { doneAsFmp: true } : undefined,
	});

export const HOME_OVERVIEW_RIGHT_PANEL_PAGE_SEGMENT: PageSegmentLoadMetric =
	createPageSegmentLoadMetric({
		key: HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY,
		// Set FMP = FCP if SSR (normally FMP = TTI)
		ssr: window.__SSR_RENDERED__ ? { doneAsFmp: true } : undefined,
	});

const expectedPageSegments = [
	HOME_OVERVIEW_RECENT_PAGE_SEGMENT,
	HOME_OVERVIEW_FEED_PAGE_SEGMENT,
	HOME_OVERVIEW_RIGHT_PANEL_PAGE_SEGMENT,
	HOME_OVERVIEW_SPACES_SECTION_SEGMENT,
];

export const CONFLUENCE_HOME_PAGE_LOAD: PageLoadMetric = createPageLoadMetric({
	key: CONFLUENCE_HOME_LOAD_KEY,
	timings: getWaterfallTimings(expectedPageSegments),
	include: expectedPageSegments,
	// Set FMP = FCP if SSR (normally FMP = TTI)
	ssr: window.__SSR_RENDERED__ ? { doneAsFmp: true } : undefined,
});
